// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"next-module--wrapper--2-YCY","project":"next-module--project--29SGH"};